<template>
  <div>
    <span v-if="data.column.field === 'required'">
      <b-form-checkbox
        v-model="nativeAd.properties.find(property => property.id === data.row.id).required"
      />
    </span>
    <span v-else-if="data.column.field === 'previewValue'">
      <b-form-input
        v-model="nativeAd.properties.find(property => property.id === data.row.id).previewValue"
        size="sm"
      />
    </span>
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import {
  computed,
} from '@vue/composition-api'
import store from '@/store'

export default {
  props: {
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const nativeAd = computed(() => store.getters.getNativeAd)

    return { nativeAd }
  },
}
</script>
